import { BridgeConnectProps } from "../../types";
import useBridgeConnect from "../../hooks/useBridgeConnect";

const BridgeConnect = (props: BridgeConnectProps) => {
  const { open, error } = useBridgeConnect({
    applicationId: props.applicationId,
    onSuccess: props.onSuccess,
    onExit: props.onExit,
    onFailure: props.onFailure,
  });

  if (error) {
    throw new Error("BridgeConnect is not loaded");
  }

  return (
    <button
      onClick={open}
      aria-label="Connect to Bridge"
      style={{
        display: "flex",
        alignItems: "center",
        padding: "10px 20px",
        outline: "none",
        background: "#000000", // Black background color
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        transition: "background 0.3s, transform 0.2s",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        margin: "10px",
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.background = "#333333"; // Slightly lighter black on hover
        e.currentTarget.style.transform = "translateY(-2px)"; // Slight lift on hover
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.background = "#000000"; // Original black color
        e.currentTarget.style.transform = "translateY(0)"; // Reset transform
      }}
      onFocus={(e) => {
        e.currentTarget.style.boxShadow = "0 0 0 3px rgba(180, 241, 50, 0.5)"; // Focus outline
      }}
      onBlur={(e) => {
        e.currentTarget.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)"; // Remove focus outline
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
          background: "#B4F132", // Original green color
          borderRadius: "8px",
          marginRight: "10px",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="200"
          height="200"
          fill="none"
          viewBox="0 0 400 400"
        >
          <rect width="400" height="400" fill="#B4F132" rx="24"></rect>
          <path
            fill="#060606"
            d="M49 215.333c0-8.744 6.957-15.833 15.538-15.833H150v31.667c0 8.744-6.957 15.833-15.538 15.833H64.539C55.956 247 49 239.911 49 231.167v-15.834zM251 199.5h85.462c8.581 0 15.538 7.089 15.538 15.833v15.834c0 8.744-6.957 15.833-15.538 15.833h-69.924c-8.581 0-15.538-7.089-15.538-15.833V199.5zM150 167.833c0-8.744 6.957-15.833 15.538-15.833h69.924c8.581 0 15.538 7.089 15.538 15.833V199.5H150v-31.667z"
          ></path>
        </svg>
      </div>
      <span style={{ color: "white", fontSize: "16px", fontWeight: "bold" }}>
        Connect
      </span>
    </button>
  );
};

export default BridgeConnect;
